import { toCamelCase } from '../object-utils'
import ApiExtension from './api-extension'

export default class Subscriptions extends ApiExtension {
  create(data) {
    return this.apiBase
      .fetch(
        'subscriptions',
        {},
        {
          method: 'POST',
          body: JSON.stringify(data),
        }
      )
      .then(toCamelCase)
  }
}
